import React from "react";
import { FaMapMarkerAlt } from "react-icons/fa";
import { MdArrowOutward } from "react-icons/md";

const Footer = ({ openModal }) => {
    return (
        <section className="shadow mt-4"
            style={{
                background: "#ffffff",
                padding: "0px 0 70px",
                borderRadius: "62px 62px 0 0",
                boxShadow: "0 -20px 40px rgba(0,0,0,0.08)",
            }}
        >
            <div className="container">
                {/* MAIN CARD */}
                <div
                    className="row align-items-center g-3 p-lg-5 p-3"
                    style={{
                        // background: "#ffffff",
                        borderRadius: "60px",
                    }}
                >
                    {/* LEFT SIDE */}
                    <div className="col-lg-7 mb-4 mb-lg-0">
                        <div className="row p-lg-3 p-1 g-4" style={{ background: '#F5DCDD33', borderRadius: "25px" }}>
                            <div className="col-lg-6">
                                <h3
                                    style={{
                                        fontWeight: "700",
                                        fontSize: "26px",
                                        marginBottom: "15px",
                                    }}
                                >
                                    Jaipur, Kukas{" "}
                                    <FaMapMarkerAlt
                                        style={{ color: "#e11b22", fontSize: "20px" }}
                                    />
                                </h3>
                                <p
                                    style={{
                                        color: "#555",
                                        fontSize: "15px",
                                        lineHeight: "24px",
                                    }}
                                >
                                    SP-40, RIICO Industrial Area, <br />
                                    Kukas, Jaipur, Rajasthan, 302028
                                </p>

                                <button
                                    style={{
                                        marginTop: "20px",
                                        background: "#3c3c3c",
                                        color: "#fff",
                                        padding: "12px 22px",
                                        borderRadius: "10px",
                                        border: "none",
                                        fontSize: "14px",
                                        display: "flex",
                                        alignItems: "center",
                                        gap: "8px",
                                    }}
                                    onClick={() => openModal("Apply Now")}
                                >
                                    Book Campus Tour →
                                </button>
                            </div>
                            <div className="col-lg-6">
                                {/* CENTER IMAGE */}

                                <img
                                    className="w-100"
                                    src="/images/campus.webp"
                                    alt="Campus"
                                    style={{
                                        // width: "100%",
                                        borderRadius: "25px",
                                        boxShadow: "0 15px 35px rgba(0,0,0,0.15)",
                                    }}
                                />
                            </div>
                        </div>
                    </div>

                    <div className="col-lg-1"></div>


                    {/* RIGHT SIDE */}
                    <div className="col-lg-4 text-lg-start text-center">
                        <div
                            style={{
                                display: "flex",
                                alignItems: "center",
                                // justifyContent: "center",
                                justifyContent: window.innerWidth > 992 ? "flex-start" : "center",
                                gap: "15px",
                                flexWrap: "wrap",
                            }}
                        >
                            <img className="footer-logo"
                                src="/images/logo.webp"
                                alt="logo"
                            />
                        </div>

                        <button className="d-none d-sm-block" onClick={() => openModal("Apply Now")}
                            style={{
                                marginTop: "30px",
                                background: "#e11b22",
                                color: "#fff",
                                padding: "14px 32px",
                                borderRadius: "40px",
                                border: "none",
                                fontWeight: "600",
                                fontSize: "16px",
                                boxShadow: "0 8px 20px rgba(225,27,34,0.35)",
                                display: "inline-flex",
                                alignItems: "center",
                                gap: "8px",
                            }}
                        >
                            Apply Now <MdArrowOutward />
                        </button>
                    </div>
                </div>

                {/* COPYRIGHT */}
                <div
                    className="text-center"
                    style={{
                        marginTop: "35px",
                        color: "#666",
                        fontSize: "14px",
                    }}
                >
                    Copyright Arya College © 2026
                </div>
            </div>
        </section>
    );
};

export default Footer;